export default __webpack_public_path__ + "static/media/010_home.hevc.bbcdf172.mp4";